import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Star, Sparkles } from "lucide-react";
import { CharacterAvatar } from "@/components/characters/CharacterAvatar";

const NotFound = () => {
  // Randomly select a confused character
  const lostCharacter = useMemo(() => {
    const characters = ["buddy", "robo", "sparkle", "wise", "star", "nova"];
    return characters[Math.floor(Math.random() * characters.length)];
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-kid-purple/20 via-kid-pink/20 to-kid-blue/20 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Floating decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            {i % 2 === 0 ? (
              <Star className="w-6 h-6 text-kid-yellow/30 fill-kid-yellow/30" />
            ) : (
              <Sparkles className="w-5 h-5 text-kid-pink/30" />
            )}
          </div>
        ))}
      </div>

      <div className="text-center relative z-10 max-w-2xl">
        {/* Character with confused expression */}
        <div className="relative inline-block mb-8">
          <CharacterAvatar character={lostCharacter as any} size="xl" animated />
          <div className="absolute -top-4 -right-4 w-20 h-20 bg-kid-yellow/80 rounded-full flex items-center justify-center animate-wiggle">
            <span className="text-5xl">🗺️</span>
          </div>
        </div>

        {/* 404 Text */}
        <h1 className="text-9xl font-bubblegum font-bold mb-4 bg-gradient-to-r from-kid-purple via-kid-pink to-kid-yellow bg-clip-text text-transparent">
          404
        </h1>

        <h2 className="text-5xl font-bubblegum font-bold mb-4 text-gray-800">
          Oops! We Got Lost! 🤔
        </h2>

        <p className="text-2xl font-comic text-gray-600 mb-8 max-w-md mx-auto">
          This page seems to have wandered off on an adventure. Let's get you back home!
        </p>

        <Link to="/">
          <Button 
            size="lg"
            className="text-2xl px-12 py-8 rounded-3xl bg-gradient-to-r from-kid-purple to-kid-blue font-fredoka font-bold shadow-xl hover:shadow-2xl transform hover:scale-105 hover:-rotate-1 transition-all"
          >
            <Home className="mr-3 h-8 w-8" />
            Back to Home 🏠
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
